// extracted by mini-css-extract-plugin
export default {"edgeLabel":"ClassroomCanvasEdge_edgeLabel__WZv8r","edgeLabelSelected":"ClassroomCanvasEdge_edgeLabelSelected__2JNWX","edgeLabelGroup":"ClassroomCanvasEdge_edgeLabelGroup__GqGge"};